<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-card class="mx-auto pb-5 mb-5" color="transparent" elevation="0">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1">Zákazníci</v-list-item-title>
            <v-list-item-subtitle>V marketingu platí zásada, že treba prezentovať výhody a nie vlastnosti produktov. Pomôžte zákazníkovi vyriešiť jeho problém, splniť jeho túžbu.</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-row>
    <v-row no-gutters>
      <v-col class="px-5">
        <CustomerList />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CustomerList from "./components/CustomerList";

export default {
  name: "Customer",
  components: {
    CustomerList
  }
};
</script>
